module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Black.06b2516.ttf";